export const isInactive = (row: any, name: string) => {
  if (name.indexOf('PIES') >= 0) {
    // items
    return row.item_count === 0;
  } else if (name.indexOf('ITEMS') >= 0) {
    // items
    return row.item_count === 0;
  } else if (name.indexOf('ACES') >= 0) {
    // fitments
    return row.app_count === 0;
  } else if (name.indexOf('FITMENTS') >= 0) {
    // fitments
    return row.app_count === 0;
  }
  // assets
  return row.asset_count === 0;
};
